<template>
  <div>
    <div class="container-fluid">
      <!-- <pre>{{customer}}</pre> -->
      <div class="row">
        <div class="col-xl-3 col-lg-4">
          <aside class="profile-side profile-side-sm">
            <section class="box-typical profile-side-user-sm box-card-header-sm text-left">
              <b-row>
                <div class="col-sm-9">
                  <h5>
                    <strong>{{customer.business_name}}</strong>
                  </h5>
                  <p class="font-size-13">
                    CC/NIT {{customer.identification}}
                    <span
                      v-if="customer.check_digit != null"
                    >- {{customer.check_digit}}</span>
                    <small>({{customer.type_name}})</small>
                  </p>
                  <p class="font-size-13">
                    <strong>Asesor comercial:</strong>
                    {{customer.staff_name}}
                  </p>
                </div>
                <div class="col-sm-3 text-right">
                  <b-button
                    size="sm"
                    variant="primary"
                    class="mr-1"
                    title="Editar"
                    @click="editCustomer"
                  >
                    <i class="fa fa-edit"></i>
                  </b-button>
                </div>
              </b-row>
              <b-row class="mt-2">
                <b-col>
                  <b-form-select
                    v-model="customer.advance"
                    class="custom-select-trebol-primary"
                    @change="getAdvanceLevel()"
                  >
                    <option
                      v-for="item in lstAdvance"
                      :key="item.id"
                      :value="item.id"
                    >{{ item.name }}</option>
                  </b-form-select>
                </b-col>
                <b-col>
                  <b-form-select
                    v-model="customer.advance_level"
                    class="custom-select-trebol-danger"
                    @change="changeAdvanceLevel()"
                  >
                    <option
                      v-for="item in lstAdvanceLevel"
                      :key="item.id"
                      :value="item.id"
                    >{{ item.name }}</option>
                  </b-form-select>
                </b-col>
              </b-row>
            </section>

            <section class="box-typical">
              <div class="box-typical-inner">
                <p class="mb-1">
                  <strong>INFORMACIÓN GENERAL</strong>
                </p>
                <hr class="mb-3 mt-0" />

                <div v-if="visible(customer.lstAddress)">
                  <p class="line-with-icon" v-if="visible(customer.lstAddress[0].lstMail[0])">
                    <strong>Correo:</strong>
                    <a href="#">{{customer.lstAddress[0].lstMail[0].value}}</a>
                  </p>

                  <p class="line-with-icon" v-if="visible(customer.lstAddress[0].lstPhone)">
                    <strong>Teléfono:</strong>
                    {{customer.lstAddress[0].lstPhone[0].value}}
                  </p>

                  <p class="line-with-icon" v-if="visible(customer.lstAddress[0].lstMobile)">
                    <strong>Celular:</strong>
                    {{customer.lstAddress[0].lstMobile[0].value}}
                  </p>

                  <p class="line-with-icon" v-if="visible(customer.lstAddress[0].address)">
                    <strong>Dirección:</strong>
                    {{customer.lstAddress[0].address}}
                  </p>

                  <p class="line-with-icon" v-if="visible(customer.lstAddress[0].neighborhood)">
                    <strong>Barrio:</strong>
                    {{customer.lstAddress[0].neighborhood}}
                  </p>

                  <p class="line-with-icon" v-if="visible(customer.lstAddress[0].zone_name)">
                    <strong>Departamento:</strong>
                    {{customer.lstAddress[0].zone_name}}
                  </p>

                  <p class="line-with-icon" v-if="visible(customer.lstAddress[0].city_name)">
                    <strong>Ciudad:</strong>
                    {{customer.lstAddress[0].city_name}}
                  </p>

                  <a
                    href="#"
                    target="_blank"
                    data-toggle="modal"
                    data-target="#dlgDireccion"
                  >Ver todo</a>
                </div>

                <div v-if="contact && contact.id">
                  <p class="mt-3 mb-1">
                    <strong>CONTACTOS</strong>
                  </p>
                  <hr class="mb-3 mt-0" />

                  <p class="line-with-icon" v-if="contact.name">
                    <strong>Nombre:</strong>
                    {{contact.name}} {{contact.last_name }}
                  </p>

                  <p class="line-with-icon" v-if="contact.occupation">
                    <strong>Cargo:</strong>
                    {{contact.occupation}}
                  </p>

                  <p class="line-with-icon" v-if="contact.mail">
                    <strong>Correo:</strong>
                    <a href="javascript:void(0);">{{contact.mail}}</a>
                  </p>

                  <p class="line-with-icon" v-if="contact.phone_number">
                    <strong>Teléfono:</strong>
                    <a
                      href="javascript:void(0);"
                    >+{{contact.phone_zone}} {{contact.phone_area}} {{contact.phone_number}}</a>
                  </p>

                  <p class="line-with-icon" v-if="contact.mobile_number">
                    <strong>Celular:</strong>
                    <a
                      href="javascript:void(0);"
                    >+{{contact.mobile_zone}} {{contact.mobile_area}} {{contact.mobile_number}}</a>
                  </p>

                  <p class="line-with-icon" v-if="contact.birthday_date">
                    <strong>Cumpleaños:</strong>
                    {{formatBirthdate(contact.birthday_date)}}
                  </p>

                  <a
                    href="#"
                    target="_blank"
                    data-toggle="modal"
                    data-target="#dlgContactos"
                  >Ver todos</a>
                </div>

                <div v-if="visible(customer.observation)">
                  <p class="mt-3 mb-1">
                    <strong>COMENTARIOS</strong>
                  </p>
                  <hr class="mb-3 mt-0" />

                  <p class="line-with-icon text-justify">{{customer.observation}}</p>
                </div>
              </div>
            </section>
          </aside>
        </div>

        <div class="col-xl-9 col-lg-8">
          <!-- INICIO INFORMACION FINANCIERA -->
          <div class="row" v-if="false">
            <div class="col-sm-3 card-price">
              <div class="row">
                <div class="card-price-img">
                  <img src="img/icons/003-wallet.svg" />
                </div>
                <div class="card-price-body">
                  <p class="text-primary">CARTERA PENDIENTE</p>
                  <p>
                    <strong>$ 5’000.000</strong>
                  </p>
                </div>
              </div>
            </div>

            <div class="col-sm-2 card-price">
              <div class="row">
                <div class="card-price-img">
                  <img src="img/icons/001-business-and-finance.svg" />
                </div>
                <div class="card-price-body">
                  <p class="text-primary">INTERESES</p>
                  <p>
                    <strong>$ 5’000.000</strong>
                  </p>
                </div>
              </div>
            </div>

            <div class="col-sm-2 card-price">
              <div class="row">
                <div class="card-price-img">
                  <img src="img/icons/002-coin.svg" />
                </div>
                <div class="card-price-body">
                  <p class="text-primary">HONORARIOS</p>
                  <p>
                    <strong>$ 5’000.000</strong>
                  </p>
                </div>
              </div>
            </div>

            <div class="col-sm-2 card-price">
              <div class="row">
                <div class="card-price-img">
                  <img src="img/icons/003-undo-button.svg" />
                </div>
                <div class="card-price-body">
                  <p class="text-primary">RECUPERADA</p>
                  <p>
                    <strong>$ 5’000.000</strong>
                  </p>
                </div>
              </div>
            </div>

            <div class="col-sm-3 card-price">
              <div class="row">
                <div class="card-price-img">
                  <img src="img/icons/004-handshake.svg" />
                </div>
                <div class="card-price-body">
                  <p class="text-primary">COMPROMISOS</p>
                  <p>
                    <strong>$ 5’000.000</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- FIN INFORMACION FINANCIERA -->

          <!-- INICIO TABS DE PRUEBA -->

          <div class="row mt-4 tbs-customer">
            <b-tabs
              justified
              class="w100 custom-tabs"
              active-nav-item-class="font-weight-bold text-success"
            >
              <b-tab title="Gestión" active>
                <form class="box-typical" v-if="CREATE">
                  <textarea
                    type="text"
                    class="write-something"
                    rows="3"
                    :placeholder="`- Ingresa tu gestión`"
                    v-model="gestion.management"
                  ></textarea>

                  <div class="box-typical-footer">
                    <div class="tbl">
                      <div class="tbl-row">
                        <b-row>
                          <b-col sm="2">
                            <b-form-group>
                              <date-picker
                                v-if="options"
                                id="txtFecha"
                                name="date"
                                v-model="gestion.date"
                                :config="options"
                                placeholder="Fecha"
                                @dp-change="validarTiempoDiarioGestiones(gestion)"
                              ></date-picker>
                            </b-form-group>
                          </b-col>

                          <b-col sm="2">
                            <b-form-group>
                              <b-form-select
                                v-model="gestion.type"
                                @change="getTaskByType(gestion.type, false)"
                              >
                                <template slot="first">
                                  <option :value="null" disabled>-- Tipo Gestión --</option>
                                </template>

                                <option
                                  v-for="item in lstTipoGestion"
                                  :key="item.id"
                                  :value="item.id"
                                >{{ item.name }}</option>
                              </b-form-select>
                            </b-form-group>
                          </b-col>

                          <b-col sm="2">
                            <b-form-group>
                              <b-form-select
                                v-model="gestion.minutes"
                                @change="validarTiempoDiarioGestiones(gestion)"
                              >
                                <template slot="first">
                                  <option :value="null" disabled>-- Tiempo --</option>
                                </template>
                                <option value="5">5 min</option>
                                <option value="10">10 min</option>
                                <option value="15">15 min</option>
                                <option value="30">30 min</option>
                                <option value="45">45 min</option>
                                <option value="60">60 min (1 h)</option>
                                <option value="90">90 min (1.5 h)</option>
                                <option value="120">120 min (2 h)</option>
                                <option value="150">150 min (2.5 h)</option>
                                <option value="180">180 min (3 h)</option>
                                <option value="240">240 min (4 h)</option>
                                <option value="300">300 min (5 h)</option>
                                <option value="360">360 min (6 h)</option>
                                <option value="420">420 min (7 h)</option>
                                <option value="480">480 min (8 h)</option>
                              </b-form-select>
                            </b-form-group>
                          </b-col>

                          <b-col sm="3">
                            <b-form-group>
                              <b-form-select
                                v-model="taskEdit_id"
                                @change="selectedTask(taskEdit_id, false)"
                              >
                                <template slot="first">
                                  <option :value="null" disabled>-- Actividad --</option>
                                </template>

                                <option
                                  v-for="item in lstTaskEdit"
                                  :key="item.id"
                                  :value="item.id"
                                >{{ item.date }} - {{ item.name }}</option>
                              </b-form-select>
                            </b-form-group>
                          </b-col>

                          <b-col sm="2">
                            <b-form-group>
                              <b-form-select
                                v-model="gestion.status_id"
                                :disabled="gestion.task_id == null"
                              >
                                <template slot="first">
                                  <option :value="null" disabled>-- Actualizar estado --</option>
                                </template>

                                <option
                                  v-for="item in lstTaskStatus"
                                  :key="item.id"
                                  :value="item.id"
                                >{{ item.name }}</option>
                              </b-form-select>
                            </b-form-group>
                          </b-col>

                          <b-col sm="1">
                            <b-form-group>
                              <button
                                type="button"
                                class="btn btn-success"
                                @click="guardarGestion()"
                              >Enviar</button>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                  </div>
                </form>

                <div
                  class="without"
                  v-if="!lstGestion ||  lstGestion.length == 0"
                  style="margin-top:0px"
                >
                  <div class="row">
                    <figure class="text-center">
                      <img src="img/sin_gestion.png" alt width="210px" />
                    </figure>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-center">
                      <h1>Oops!</h1>
                      <h4>
                        Parece que no hay
                        <br />gestiones en esta cuenta.
                      </h4>
                    </div>
                  </div>
                </div>

                <div class="comments" v-else>
                  <strong>
                    <p>Historial de gestiones</p>
                  </strong>
                  <!--.init box-typical-->
                  <section
                    class="box-typical comment box-typical-custom"
                    v-for="item in lstGestion"
                    :key="item.id"
                  >
                    <div class="row">
                      <div class="col-sm-2 mr-0">
                        <div class="row">
                          <div class="col-md-12 text-center">
                            <strong>
                              <p>CREADA POR</p>
                            </strong>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12 text-center">
                            <img
                              v-if="item.user_image === null"
                              src="img/avatars/avatar-2-64.png"
                              class="rounded-circle"
                            />
                            <img v-else :src="item.user_image" class="rounded-circle img-gestion" />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12 text-center">
                            <p>{{item.user_name}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-10">
                        <div class="row">
                          <div class="col-sm-9">
                            <strong>
                              <p>COMENTARIO</p>
                            </strong>
                          </div>
                          <div class="col-sm-3 text-right">
                            <b-button
                              size="sm"
                              variant="info"
                              class="mr-1"
                              title="Editar"
                              @click="editGestion(item)"
                              :disabled="role_id == 1 ? false : (role_id == 7 ? !UPDATE : user_id != item.user_id && !UPDATE)"
                            >
                              <i class="fa fa-edit"></i>
                            </b-button>

                            <b-button
                              size="sm"
                              variant="danger"
                              title="Eliminar"
                              @click="deleteGestion(item)"
                              :disabled="role_id == 1 ? false : (role_id == 7 ? !DELETE : user_id != item.user_id && !DELETE)"
                            >
                              <i class="fa fa-trash"></i>
                            </b-button>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12 text-justify">
                            <p>{{item.management}}</p>
                          </div>
                        </div>
                        <hr />
                        <div class="row row-footer">
                          <div class="col">
                            <p>
                              <strong>FECHA</strong>
                            </p>
                            <p>{{item.date}}</p>
                          </div>

                          <div class="col">
                            <p>
                              <strong>TIPO DE GESTIÓN</strong>
                            </p>
                            <p>{{item.type_name}}</p>
                          </div>

                          <div class="col">
                            <p>
                              <strong>TIEMPO</strong>
                            </p>
                            <p>{{item.minutes}} min</p>
                          </div>

                          <div class="col">
                            <p>
                              <strong>ACTIVIDAD RELACIONADA</strong>
                            </p>
                            <p>{{item.task_name}}</p>
                          </div>

                          <div class="col ml-1">
                            <p>
                              <strong>ACTUALIZACIÓN ESTADO</strong>
                            </p>
                            <p>{{item.satatus_name}}</p>
                          </div>
                        </div>
                        <div class="row row-footer">
                          <div class="w100 text-right mr-2">
                            <p>
                              <i class="fa fa-clock-o"></i>
                              &nbsp;{{item.created_at}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  <!--.end box-typical-->

                  <nav v-if="paginationGestion.last_page>1" aria-label="Page navigation example">
                    <ul class="pagination justify-content-end pagination-sm">
                      <li v-if="paginationGestion.current_page==1" class="page-item disabled">
                        <a class="page-link" tabindex="-1">Anterior</a>
                      </li>
                      <li v-else class="page-item">
                        <a
                          class="page-link"
                          tabindex="-1"
                          @click="getTaskManagement(paginationGestion.prev_page_url)"
                        >Anterior</a>
                      </li>

                      <div v-for="page in paginationGestion.last_page" :key="page" :value="page">
                        <li v-if="paginationGestion.current_page==page" class="page-item active">
                          <a class="page-link">{{ page }}</a>
                        </li>
                        <li v-else class="page-item">
                          <a
                            class="page-link"
                            @click="getTaskManagement(paginationGestion.path+'?page='+page)"
                          >{{ page }}</a>
                        </li>
                      </div>
                      <li
                        v-if="paginationGestion.current_page==paginationGestion.last_page"
                        class="page-item disabled"
                      >
                        <a class="page-link">Siguiente</a>
                      </li>
                      <li v-else class="page-item">
                        <a
                          class="page-link"
                          @click="getTaskManagement(paginationGestion.next_page_url)"
                        >Siguiente</a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </b-tab>

              <b-tab title="Actividades">
                <b-col>
                  <div class="row">
                    <div class="col-sm-8">&nbsp;</div>

                    <div class="col-sm-4 text-right">
                      <button class="btn btn-sm btn-success" type="button" @click="addtask()" :disabled="!CREATE">
                        Añadir nueva actividad
                        <!-- <i class="fa fa-plus"></i> -->
                      </button>
                    </div>
                  </div>
                </b-col>

                <section class="without" v-if="!lstTasks.length > 0" style="margin-top:60px">
                  <div class="row">
                    <figure class="text-center">
                      <img src="img/sin_datos.png" alt width="210px" />
                    </figure>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-center">
                      <h1>Oops!</h1>
                      <h4>
                        No hay actividades
                        <br />en esta cuenta.
                      </h4>
                    </div>
                  </div>
                </section>

                <section v-else>
                  <b-col>
                    <div class="row">
                      <div class="col-sm-4">
                        <b-form-group>
                          <b-form-select
                            :disabled="!UPDATE"
                            id="cmbEstado"
                            v-model="task_status"
                            @change="actualizarEstadoTask()"
                          >
                            <template slot="first">
                              <option :value="null" disabled>-- Actualizar Estado--</option>
                            </template>
                            <option
                              v-for="item in lstStatusTask"
                              :key="item.id"
                              :value="item.id"
                            >{{ item.name }}</option>
                          </b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                  </b-col>

                  <b-table
                    :hover="hover"
                    :striped="striped"
                    :bordered="bordered"
                    :small="small"
                    :fixed="fixed"
                    responsive="sm"
                    :items="lstTasks"
                    :fields="fields_task"
                    :current-page="currentPageTask"
                    :per-page="perPage"
                  >
                    <template slot="HEAD_selected">
                      <input
                        type="checkbox"
                        @click.stop
                        v-model="selectAllTask"
                        @change="toggleSelectAllTask"
                      />
                    </template>

                    <template slot="selected" slot-scope="data">
                      <input
                        type="checkbox"
                        v-model="data.item.selected"
                        @change="selectRowTask(data.item)"
                      />
                    </template>

                    <!-- <template v-slot:cell(actions)="data"> -->
                    <template slot="actions" slot-scope="data">
                      <b-button
                        size="sm"
                        variant="primary"
                        class="mr-1"
                        title="ver"
                        @click="viewtask(data.item)"
                        :disabled="!READ"
                      >
                        <i class="fa fa-eye"></i>
                      </b-button>

                      <b-button
                        size="sm"
                        variant="success"
                        class="mr-1"
                        title="Editar"
                        @click="edittask(data.item)"
                        :disabled="!UPDATE"
                      >
                        <i class="fa fa-edit"></i>
                      </b-button>

                      <b-button
                        size="sm"
                        variant="danger"
                        @click="deletetask(data.item.id)"
                        title="Eliminar"
                        :disabled="!DELETE"
                      >
                        <i class="fa fa-trash"></i>
                      </b-button>
                    </template>
                  </b-table>
                  <nav>
                    <b-pagination
                      size="sm"
                      :total-rows="getRowCount(lstTasks)"
                      :per-page="perPage"
                      v-model="currentPageTask"
                      prev-text="Anterior"
                      next-text="Siguiente"
                    />
                  </nav>
                </section>
              </b-tab>

              <b-tab title="Contratos" @click="renderServiceOrderComponent = false">
                <agreement-component :_customer_id="this.$route.params.id" />
              </b-tab>

              <b-tab title="Ordenes de servicio" @click="renderServiceOrderComponent = true">
                <service-order-component
                  :_customer_id="this.$route.params.id"
                  v-if="renderServiceOrderComponent == true"
                />
              </b-tab>

              <!-- <b-tab title="Cartera">

                <section v-if="lstDebtor.length == 0" class="without">
                  <div class="row">
                    <figure class="text-center"> <img src="img/sin_datos.png" alt="" width="210px"></figure>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-center">
                      <h1>Oops!</h1>
                      <h4>Aún no tienes deudores <br> para este cliente.</h4>
                    </div>
                  </div>
                </section>
                <section v-else>
                  <b-card :header="captionDebtor">
                    <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="lstDebtor" :fields="fields" :current-page="currentPage" :per-page="perPage" >
                        <template slot="actions" slot-scope="data" >

                          <b-button size="sm" variant="success" class="mr-1" title="Editar" @click="editDebtor(data.item.id)">
                            <i class="fa fa-edit"></i>
                          </b-button>

                          <b-button size="sm" variant="danger" title="Eliminar">
                            <i class="fa fa-trash"></i>
                          </b-button>
                      </template>
                    </b-table>
                    <nav>
                      <b-pagination size="sm" :total-rows="getRowCount(lstDebtor)" :per-page="perPage" v-model="currentPage" prev-text="Ant" next-text="Sig" />
                    </nav>
                  </b-card>
                </section>
              </b-tab>-->

              <b-tab title="Documentos" @click="getDocuments()">
                <section v-if="CREATE">
                  <strong>
                    <p>Subir documento</p>
                  </strong>
                  <uploadFile
                    :uri="this.$urlApi"
                    :tok="this.token"
                    :table="this.table"
                    :id="this.$route.params.id"
                    @newfile="addFile"
                  ></uploadFile>
                </section>
                <section class="without" v-if="!lstDocument.length > 0" style="margin-top:0px">
                  <div class="row">
                    <figure class="text-center">
                      <img src="img/sin_adjuntos.png" alt width="150px" />
                    </figure>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-center">
                      <h1>Oops!</h1>
                      <h4>
                        No hay archivos adjuntos
                        <br />en esta cuenta.
                      </h4>
                    </div>
                  </div>
                </section>

                <section v-else>
                  <div v-if="isAdmin">
                    <b-col cols="8 mt-5 mb-2">
                      <div class="row" v-if="false">
                        <div class="col-sm-3">
                          <b-button variant="danger" class="float-right col-sm-12 btn-sm" :disabled="!DELETE">Eliminar</b-button>
                        </div>
                      </div>
                    </b-col>

                    <b-table
                      :hover="hover"
                      :striped="striped"
                      :bordered="bordered"
                      :small="small"
                      :fixed="fixed"
                      responsive="sm"
                      :items="lstDocument"
                      :fields="fields_file"
                    >
                      <template slot="HEAD_selected">
                        <input
                          type="checkbox"
                          @click.stop
                          v-model="selectAll"
                          @change="toggleSelectAll"
                        />
                      </template>

                      <template slot="selected" slot-scope="data">
                        <input
                          type="checkbox"
                          v-model="data.item.selected"
                          @change="selectRow(data.item)"
                        />
                      </template>

                      <template slot="actions" slot-scope="data">
                      <!-- <template v-slot:cell(actions)="data"> -->
                        <b-button
                          size="sm"
                          variant="success"
                          class="mr-1"
                          title="Descargar"
                          @click="dowloadDocument(data.item)"
                          :disabled="!READ"
                        >
                          <i class="fa fa-arrow-down"></i>
                        </b-button>

                        <b-button
                          size="sm"
                          variant="danger"
                          @click="deleteFile(data.item.id)"
                          title="Eliminar"
                          :disabled="!DELETE"
                        >
                          <i class="fa fa-trash"></i>
                        </b-button>
                      </template>
                    </b-table>
                  </div>
                </section>
              </b-tab>
            </b-tabs>
          </div>
          <!-- FIN TABS DE PRUEBA -->
        </div>
      </div>
    </div>

    <!-- MODAL PARA MOSTRAR LOS CONTACTOS DEL CLIENTE -->
    <div class="modal" id="dlgContactos" v-if="visible(customer.lstContacto)">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <section>
              <div class="box-typical-inner">
                <h4>
                  <strong>CONTACTOS</strong>
                </h4>

                <hr class="mt-2 mb-3" />

                <div v-for="item in customer.lstContacto" :key="item.id" :value="item.id">
                  <p class="line-with-icon" v-if="item.name">
                    <strong>Nombre:</strong>
                    {{item.name}} {{item.last_name }}
                  </p>

                  <p class="line-with-icon" v-if="item.occupation">
                    <strong>Cargo:</strong>
                    {{item.occupation}}
                  </p>

                  <p class="line-with-icon" v-if="item.mail">
                    <strong>Correo:</strong>
                    <a href="#">{{item.mail}}</a>
                  </p>

                  <p class="line-with-icon" v-if="item.phone_number">
                    <strong>Teléfono:</strong>
                    +{{item.phone_zone}} {{item.phone_area}} {{item.phone_number}}
                  </p>

                  <p class="line-with-icon" v-if="item.mobile_number">
                    <strong>Celular:</strong>
                    +{{item.mobile_zone}} {{item.mobile_area}} {{item.mobile_number}}
                  </p>

                  <p class="line-with-icon" v-if="item.birthday_date">
                    <strong>Cumpleaños:</strong>
                    {{item.birthday_date}}
                  </p>

                  <hr class="mt-2 mb-3" />
                </div>

                <button class="btn btn-success col-sm-2 center-block" data-dismiss="modal">Aceptar</button>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
    <!-- FIN MODAL PARA MOSTRAR LOS CONTACTOS DEL CLIENTE -->

    <!-- MODAL PARA EL COMPONENTE DE CREAR ACTIVIDADES O TASK -->
    <div class="modal fade" id="dlgCrearActividad">
      <div class="modal-dialog modal-dialog-centered modal-success">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">ACTIVIDAD</h4>
            <button type="button" class="close" @click="closetask()">&times;</button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <activity-component
              :customer_id="this.customer_id"
              :private="'S'"
              :_task="this.taskSelected"
              :_disabled="this.disabledTask"
              :dlg="'dlgCrearActividad'"
              v-if="customer_id"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- FIN MODAL PARA EL COMPONENTE DE CREAR ACTIVIDADES O TASK -->

    <!-- MODAL PARA MOSTRAR LAS DIRECCIONES DEL CLIENTE -->
    <div class="modal" id="dlgDireccion">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <section>
              <div class="box-typical-inner">
                <h5 class="mb-0">
                  <strong>{{customer.business_name}}</strong>
                </h5>
                <p class="font-size-13 mt-0">
                  CC/NIT {{customer.identification}}
                  <span
                    v-if="customer.check_digit"
                  >- {{customer.check_digit}}</span>
                  &nbsp;({{customer.type_name}})
                </p>

                <hr class="mt-2 mb-3" />
                <div class="row">
                  <div class="col-sm-6">
                    <p class="font-size-13 mb-0">
                      <strong>Origen:</strong>
                      {{customer.source_name}}
                      <span
                        v-if="customer.source_staff_name"
                      >({{customer.source_staff_name}})</span>
                    </p>
                    <p class="font-size-13 mb-0">
                      <strong>Estado en el sistema:</strong>
                      {{customer.status_name}}
                    </p>
                    <p class="font-size-13 mb-0">
                      <strong>Avance:</strong>
                      {{customer.advance_name}}
                    </p>
                    <p class="font-size-13 mb-0">
                      <strong>Nivel:</strong>
                      {{customer.advance_level_name}}
                    </p>
                  </div>

                  <div class="col-sm-6">
                    <p class="font-size-13 mb-0">
                      <strong>Atendido por:</strong>
                      {{customer.staff_name}}
                    </p>
                    <p class="font-size-13 mb-0">
                      <strong>Industria:</strong>
                      {{customer.industries_name}}
                    </p>
                    <p class="font-size-13 mb-0 text-justify">
                      <strong>Sub Industria:</strong>
                      {{customer.sub_industries_name}}
                    </p>
                  </div>
                </div>

                <div v-if="visible(customer.lstAddress)">
                  <p class="mb-1 mt-3">
                    <strong>INFORMACIÓN DE CONTACTO</strong>
                  </p>
                  <hr class="mb-3 mt-0" />

                  <div v-for="(item, index) in customer.lstAddress" :key="item.id" :value="item.id">
                    <p class="font-size-14 mb-1">
                      <strong>Dirección {{index + 1}}</strong>
                    </p>

                    <div class="row">
                      <div class="col-sm-6">
                        <div
                          v-for="(itemMobile, i) in item.lstMobile"
                          :key="itemMobile.value"
                          :value="itemMobile.key"
                        >
                          <p class="font-size-13 mb-0">
                            <strong>Celular {{i+1}}:</strong>
                            {{itemMobile.value}}
                          </p>
                        </div>

                        <div
                          v-for="(itemPhone, j) in item.lstPhone"
                          :key="itemPhone.value"
                          :value="itemPhone.key"
                        >
                          <p class="font-size-13 mb-0">
                            <strong>Teléfono {{j+1}}:</strong>
                            {{itemPhone.value}}
                          </p>
                        </div>

                        <div
                          v-for="(itemMail, k) in item.lstMail"
                          :key="itemMail.value"
                          :value="itemMail.key"
                        >
                          <p class="font-size-13 mb-0">
                            <strong>Correo electrónico {{k+1}}:</strong>
                            <a href="javascript:void(0);">{{itemMail.value}}</a>
                          </p>
                        </div>
                      </div>

                      <div class="col-sm-6">
                        <p class="font-size-13 mb-0">
                          <strong>Dirección:</strong>
                          {{item.address}}
                        </p>
                        <p class="font-size-13 mb-0">
                          <strong>Barrio:</strong>
                          {{item.neighborhood}}
                        </p>
                        <p class="font-size-13 mb-0">
                          <strong>Departamento:</strong>
                          {{item.zone_name}}
                        </p>
                        <p class="font-size-13 mb-0">
                          <strong>Ciudad:</strong>
                          {{item.city_name}}
                        </p>
                        <p class="font-size-13 mb-0">
                          <strong>País:</strong>
                          {{item.country_name}}
                        </p>
                      </div>
                    </div>

                    <hr
                      class="mt-2 mb-3 col-sm-10 bg-success"
                      v-if="index < customer.lstAddress.length - 1"
                    />
                  </div>
                </div>

                <div
                  v-if="visible(customer.billing_phone) || visible(customer.billing_mobile) || visible(customer.billing_mail) || visible(customer.billing_address) || visible(customer.billing_neighborhood) || visible(customer.billing_zone_name) || visible(customer.billing_city_name) || visible(customer.billing_country_name)"
                >
                  <p class="mb-1 mt-3">
                    <strong>INFORMACIÓN DE FACTURACIÓN</strong>
                  </p>
                  <hr class="mb-3 mt-0" />

                  <div class="row">
                    <div class="col-sm-6">
                      <p class="font-size-13 mb-0">
                        <strong>Celular:</strong>
                        {{customer.billing_mobile}}
                      </p>
                      <p class="font-size-13 mb-0">
                        <strong>Teléfono:</strong>
                        {{customer.billing_phone}}
                      </p>
                      <p class="font-size-13 mb-0">
                        <strong>Correo electrónico:</strong>
                        <a href="javascript:void(0);">{{customer.billing_mail}}</a>
                      </p>
                    </div>

                    <div class="col-sm-6">
                      <p class="font-size-13 mb-0">
                        <strong>Dirección:</strong>
                        {{customer.billing_address}}
                      </p>
                      <p class="font-size-13 mb-0">
                        <strong>Barrio:</strong>
                        {{customer.billing_neighborhood}}
                      </p>
                      <p class="font-size-13 mb-0">
                        <strong>Departamento:</strong>
                        {{customer.billing_zone_name}}
                      </p>
                      <p class="font-size-13 mb-0">
                        <strong>Ciudad:</strong>
                        {{customer.billing_city_name}}
                      </p>
                      <p class="font-size-13 mb-0">
                        <strong>País:</strong>
                        {{customer.billing_country_name}}
                      </p>
                    </div>
                  </div>
                </div>

                <div v-if="visible(customer.observation)">
                  <p class="mb-1 mt-3">
                    <strong>COMENTARIOS</strong>
                  </p>
                  <hr class="mb-3 mt-0" />
                  <p class="font-size-13 text-justify">{{customer.observation}}</p>
                </div>

                <button
                  class="btn btn-success col-sm-2 center-block mt-2"
                  data-dismiss="modal"
                >Aceptar</button>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
    <!-- FIN MODAL PARA MOSTRAR LAS DIRECCIONES DEL CLIENTE -->

    <!-- MODAL PARA LAS ORDENES DE SERVICIO -->
    <div class="modal fade" id="dlgGestion">
      <div class="modal-dialog modal-dialog-centered modal-success modal-lg">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">GESTIÓN</h4>
            <button type="button" class="close" @click="closeGestion">&times;</button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <form
              @submit.prevent="actualizarGestion"
              method="put"
              class="box-typical"
              v-if="gestionAux.id"
            >
              <textarea
                type="text"
                class="write-something"
                rows="3"
                :placeholder="`- Ingresa tu gestión`"
                v-model="gestionAux.management"
              ></textarea>

              <div class="box-typical-footer">
                <div class="tbl">
                  <div class="tbl-row">
                    <b-row>
                      <b-col sm="2">
                        <b-form-group>
                          <date-picker
                            v-if="options"
                            id="txtFecha"
                            name="date"
                            v-model="gestionAux.date"
                            :config="options"
                            placeholder="Fecha"
                            @dp-change="validarTiempoDiarioGestiones(gestionAux)"
                          ></date-picker>
                        </b-form-group>
                      </b-col>

                      <b-col sm="2">
                        <b-form-group>
                          <b-form-select
                            v-model="gestionAux.type"
                            @change="getTaskByType(gestionAux.type, true)"
                          >
                            <template slot="first">
                              <option :value="null" disabled>-- Tipo Gestión --</option>
                            </template>

                            <option
                              v-for="item in lstTipoGestion"
                              :key="item.id"
                              :value="item.id"
                            >{{ item.name }}</option>
                          </b-form-select>
                        </b-form-group>
                      </b-col>

                      <b-col sm="2">
                        <b-form-group>
                          <b-form-select
                            v-model="gestionAux.minutes"
                            @change="validarTiempoDiarioGestiones(gestionAux)"
                          >
                            <template slot="first">
                              <option :value="null" disabled>-- Tiempo --</option>
                            </template>
                            <option value="5">5 min</option>
                            <option value="10">10 min</option>
                            <option value="15">15 min</option>
                            <option value="30">30 min</option>
                            <option value="45">45 min</option>
                            <option value="60">60 min (1 h)</option>
                            <option value="90">90 min (1.5 h)</option>
                            <option value="120">120 min (2 h)</option>
                            <option value="150">150 min (2.5 h)</option>
                            <option value="180">180 min (3 h)</option>
                            <option value="240">240 min (4 h)</option>
                            <option value="300">300 min (5 h)</option>
                            <option value="360">360 min (6 h)</option>
                            <option value="420">420 min (7 h)</option>
                            <option value="480">480 min (8 h)</option>
                          </b-form-select>
                        </b-form-group>
                      </b-col>

                      <b-col sm="3">
                        <b-form-group>
                          <b-form-select
                            v-model="gestionAux.task_id"
                            @change="selectedTask(gestionAux.task_id, true)"
                          >
                            <template slot="first">
                              <option :value="null" disabled>-- Actividad --</option>
                            </template>

                            <option
                              v-for="item in lstTaskEditAux"
                              :key="item.id"
                              :value="item.id"
                            >{{ item.date }} - {{ item.name }}</option>
                          </b-form-select>
                        </b-form-group>
                      </b-col>

                      <b-col sm="2">
                        <b-form-group>
                          <b-form-select
                            v-model="gestionAux.status_id"
                            :disabled="gestionAux.task_id == null"
                          >
                            <template slot="first">
                              <option :value="null" disabled>-- Actualizar estado --</option>
                            </template>

                            <option
                              v-for="item in lstTaskStatus"
                              :key="item.id"
                              :value="item.id"
                            >{{ item.name }}</option>
                          </b-form-select>
                        </b-form-group>
                      </b-col>

                      <b-col sm="1">
                        <b-form-group>
                          <button type="submit" class="btn btn-success">Enviar</button>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>
            </form>
            <!--.box-typical-->
          </div>
        </div>
      </div>
    </div>
    <!-- FIN MODAL PARA LAS ORDENES DE SERVICIO -->
  </div>
</template>

<script>
import ActivityComponent from "@/components/Activity.vue";
import AgreementComponent from "@/components/Agreement.vue";
import ServiceOrderComponent from "@/components/ServiceOrder.vue";
import moment from "moment";

export default {
  name: "customerView",
  components: { ActivityComponent, AgreementComponent, ServiceOrderComponent },
  props: {
    caption: {
      type: String,
      default: "Funcionario",
    },
    captionDebtor: {
      type: String,
      default: "Deudores",
    },
    hover: {
      type: Boolean,
      default: true,
    },
    striped: {
      type: Boolean,
      default: true,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      isCustomer: false,
      options: null,
      customer_id: null,
      user_id: null,
      table: "customers",
      lstDebtor: [],
      lstTipoGestion: [],
      tipoGestion: null,
      lstTasks: [],
      selectAll: false,
      selectAllTask: false,
      fields: [
        { key: "bussiness_name", label: "Nombres" },
        { key: "identification", label: "NIT/CC" },
        { key: "address", label: "Dirección" },
        { key: "actions", label: "Opciones" },
      ],

      // CABECERAS PARA LA TABLA DE LOS DOCUMENTOS
      fields_file: [
        {
          key: "selected",
          sortable: false,
          label: "",
          class: "options-column",
        },
        { key: "type", label: "Formato" },
        { key: "agreement_number", label: "Contrato" },
        { key: "service_order_number", label: "Orden" },

        { key: "name", label: "Nombre" },
        { key: "created_at", label: "Fecha de subida" },
        { key: "actions", label: "Opciones" },
      ],

      // CABECERAS PARA LA TABLA DE LAS TASK
      fields_task: [
        {
          key: "selected",
          sortable: false,
          label: "",
          class: "options-column",
        },
        { key: "satatus_name", label: "Estado" },
        { key: "name", label: "Nombre" },
        { key: "type_name", label: "Tipo" },
        { key: "date", label: "Fecha" },
        { key: "staff_name", label: "Asignada a" },
        { key: "actions", label: "Opciones" },
      ],

      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      customer: {},
      datos: [],
      errores: [],
      contact: {},
      file: null,
      lstDocument: [],
      selectItems: [],
      selectItemsTask: [],
      documentSelected: {},
      lstStatusTask: [],
      task_status: null,
      taskSelected: null,
      disabledTask: false,

      lstStaffs: [],
      lstClassification: [],
      lstBusinessType: [],

      lstAdvance: [],
      lstAdvanceLevel: [],

      // VARIABLES PARA LAS GESTIONES
      lstTaskStatus: [],

      gestion: {
        date: null,
        minutes: null,
        type: null,
        task_id: null,
        management: null,
        customer_id: null,
        user_id: null,
        status_id: null,
      },
      lstTaskEdit: [],
      taskEdit_id: null,

      gestionAux: {
        date: null,
        minutes: null,
        type: null,
        task_id: null,
        management: null,
        customer_id: null,
        user_id: null,
        status_id: null,
      },
      lstTaskEditAux: [],
      // CABECERAS PARA LA TABLA DE LAS TASK
      fields_gestion: [{ key: "date", label: "Fecha" }],
      paginationGestion: {},
      lstGestion: [],
      perPageGestion: 1,
      currentPageGestion: 1,
      currentPageTask: 1,
      renderServiceOrderComponent: false,
      // IMPORTAR GESTIONES
      tableData: [],
      tableHeader: [],
      rowCount: -1,
      mostrarResumen: false,
      // ------------------------------------------------------------------------
      // VARIABLES PARA LA GESTÓN DE LAS ACCIONES Y PERMISOS DE CADA USUARIO
      // ------------------------------------------------------------------------
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
    };
  },
  mounted() {
    this.enabledActions();
    if (this.isAdmin) {
      this.options = {
        // https://momentjs.com/docs/#/displaying/
        format: "DD/MM/YYYY h:mm A",
        useCurrent: true,
        showClear: true,
        showClose: true,
      };
    } else {
      this.options = {
        // https://momentjs.com/docs/#/displaying/
        format: "DD/MM/YYYY h:mm A",
        useCurrent: true,
        showClear: true,
        showClose: true,
        minDate: moment().subtract(1, "d"),
        maxDate: moment(),
      };
    }

    this.initCustomer();
  },
  computed: {},
  methods: {
    enabledActions() {
      var auth = localStorage.getItem("auth");
      auth = JSON.parse(auth)[0];
      this.CREATE = auth.create == 1;
      this.READ   = auth.read == 1;
      this.UPDATE = auth.update == 1;
      this.DELETE = auth.delete == 1;
    },
    initCustomer() {
      var auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);
      this.isCustomer = auth[0].customer_id != null ? true : false;
      this.user_id = auth[0].id;

      showLoader();
      // CARGAR EL CLIENTE SELECCIONADO

      // 5: LISTADO DE ESTADO DE LAS ACTIVIDADES O TAREAS
      this.$http.get(`${this.$urlApi}parameters/5?token=${this.token}`).then(
        (response) => {
          this.lstTaskStatus = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      // 4: AVANCE CLIENTE
      this.$http.get(`${this.$urlApi}parameters/4?token=${this.token}`).then(
        (response) => {
          this.lstAdvance = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      let id = this.$route.params.id;

      this.$http
        .get(`${this.$urlApi}customers/all/${id}?token=${this.token}`)
        .then(
          (response) => {
            this.customer = response.data.data;

            // console.log(response);

            // VALIDAR SI LA CUENTA LE PERTENECE AL USUARIO QUE SE LOGEO
            this.validarPropietario(this.customer);

            this.$http
              .get(`${this.$urlApi}contacts/first/${id}?token=${this.token}`)
              .then(
                (response) => {
                  this.contact = response.data.data;
                  // console.log(response.data.data);
                },
                (error) => {
                  this.errores = getMsgError(error);
                  console.log(error);
                  hideLoader();
                }
              );

            this.getDebtors();
            this.getTaskManagement();
            this.getTasks();
            this.getAdvanceLevel();
            //this.getDocuments()

            // 5: LISTADO DE ESTADO DE LAS ACTIVIDADES O TAREAS
            this.$http
              .get(`${this.$urlApi}parameters/5?token=${this.token}`)
              .then(
                (response) => {
                  this.lstStatusTask = response.data.data;
                },
                (error) => {
                  console.log(error);
                  hideLoader();
                }
              );

            // 6: LISTADO DE TIPOS DE ACTIVIDAD (TASK)
            this.$http
              .get(`${this.$urlApi}parameters/6?token=${this.token}`)
              .then(
                (response) => {
                  this.lstTipoGestion = response.data.data;
                },
                (error) => {
                  console.log(error);
                  hideLoader();
                }
              );

            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    validarPropietario(item) {
      if (!this.isAdmin) {
        let auth = localStorage.getItem("auth");
        auth = JSON.parse(auth);
        if (!this.isCustomer && this.role_id != 1 && this.role_id != 7) {
          if(auth[0].staff_id !== item.staff_id) location.href = `${location.origin}/#/404`;
        }
      }
    },
    getDebtors() {
      showLoader();
      let id = this.$route.params.id;
      // CARGAR EL LISTADO DE DEUDORES DE ESTE CLIENTE
      this.$http
        .get(`${this.$urlApi}debtors/customer/${id}?token=${this.token}`)
        .then(
          (response) => {
            this.lstDebtor = response.data.data;
            //console.log(response.data.data)
          },
          (error) => {
            this.errores = getMsgError(error);
          }
        );
      hideLoader();
    },
    getDocuments() {
      showLoader();
      //console.log('getDocuments')

      // LISTADO DE DOCUMENTOS DEL CLIENTE O CUENTA
      let data = {
        table: this.table,
        table_id: this.$route.params.id,
        process_id: null
      };

      this.lstDocument = [];

      this.$http
        .post(
          `${this.$urlApi}documents/get?token=${this.token}`,
          JSON.stringify(data),
          { headers: { "Content-Type": "application/json" } }
        )
        .then(
          function (response) {
            // console.log(response);

            let lstDocumentAux = response.data.data;

            for (var i = 0; i < lstDocumentAux.length; i++) {
              var item = lstDocumentAux[i];
              var data_aux = null;
              if (item.data) {
                data_aux = JSON.parse(item.data);
              }

              let document = {
                id: item.id,
                created_at: item.created_at,
                data: item.data,
                name: item.name,
                path: item.path,
                agreement_number:
                  data_aux === null
                    ? null
                    : data_aux.agreement_number === null
                    ? null
                    : data_aux.agreement_number,
                service_order_number:
                  data_aux === null
                    ? null
                    : data_aux.service_order_number === null
                    ? null
                    : data_aux.service_order_number,
                table: item.table,
                table_id: item.table_id,
                type: item.type,
                updated_at: item.updated_at,
              };

              this.lstDocument.push(document);
            }

            //console.log(this.lstDocument)
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    getTasks() {
      showLoader();
      let id = this.$route.params.id;
      // CARGAR EL LISTADO DE TAREAS O ACTIVIDADES DE ESTE CLIENTE
      this.$http
        .get(`${this.$urlApi}tasks/customer/${id}?token=${this.token}`)
        .then(
          (response) => {
            this.lstTasks = response.data.data;
            //console.log(response.data.data)
          },
          (error) => {
            console.log(error);
            this.errores = getMsgError(error);
          }
        );
      hideLoader();
    },
    getRowCount(items) {
      return items.length;
    },
    goBack() {
      this.$router.go(-1);
    },
    editDebtor(id) {
      // REDIRECCIONAR A LA VISTA DE EDICION DEL DEUDOR
      location.href = `${location.origin}/#/staffs/edit/${id.toString()}`;
    },
    addFile(f) {
      this.getDocuments();
    },
    deleteFile(file_id) {
      this.$swal({
        title: "Eliminar",
        text: "Desea eliminar el documento ?",
        type: "question",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.value) {
          showLoader();
          this.$http
            .delete(`${this.$urlApi}documents/${file_id}?token=${this.token}`, {
              headers: { "Content-Type": "application/json" },
            })
            .then(function (response) {
              //console.log(response)
              hideLoader();

              this.$swal({
                title: "Buen trabajo",
                text: "Documento eliminado correctamente!",
                type: "success",
                showCancelButton: false,
                confirmButtonText: "Aceptar",
              }).then((result) => {
                if (result.value) {
                  this.getDocuments();
                }
              });
            })
            .catch((error) => {
              console.log(error.body.error);
              hideLoader();
            });
        }
      });
    },
    selectRow(item) {
      if (!item.selected) {
        if (this.selectAll) {
          this.selectAll = false;
        }
        var index = this.selectItems.indexOf(item);

        if (index > -1) {
          this.selectItems.splice(index, 1);
        }
      } else {
        this.selectItems.push(item);
      }
      //console.log(this.selectItems)
    },
    toggleSelectAll() {
      if (this.selectAll) {
        for (var i = 0; i < this.lstDocument.length; i++) {
          var updatingItem = this.lstDocument[i];
          updatingItem.selected = true;
          this.$set(this.lstDocument, i, updatingItem);
          this.selectItems.push(updatingItem);
        }
      } else {
        for (var i = 0; i < this.lstDocument.length; i++) {
          var updatingItem = this.lstDocument[i];
          updatingItem.selected = false;
          this.$set(this.lstDocument, i, updatingItem);
        }
        this.selectItems = [];
      }

      //console.log(this.selectItems)
    },
    dowloadDocument(doc) {
      window.open(`${this.$urlApi}file/${doc.name}?token=${this.token}`);
    },
    selectRowTask(item) {
      if (!item.selected) {
        if (this.selectAll) {
          this.selectAll = false;
        }
        var index = this.selectItemsTask.indexOf(item);

        if (index > -1) {
          this.selectItemsTask.splice(index, 1);
        }
      } else {
        this.selectItemsTask.push(item);
      }
      //console.log(this.selectItemsTask)
    },
    toggleSelectAllTask() {
      if (this.selectAllTask) {
        for (var i = 0; i < this.lstTasks.length; i++) {
          var updatingItem = this.lstTasks[i];
          updatingItem.selected = true;
          this.$set(this.lstTasks, i, updatingItem);
          this.selectItemsTask.push(updatingItem);
        }
      } else {
        for (var i = 0; i < this.lstTasks.length; i++) {
          var updatingItem = this.lstTasks[i];
          updatingItem.selected = false;
          this.$set(this.lstTasks, i, updatingItem);
        }
        this.selectItemsTask = [];
      }

      //console.log(this.selectItemsTask)
    },
    addtask() {
      this.errores = [];
      $("#dlgCrearActividad").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.customer_id = this.$route.params.id;
      $("#dlgCrearActividad").modal("show");
    },
    closetask() {
      this.taskSelected = null;
      this.customer_id = null;
      this.disabledTask = false;
      this.getTasks();
      $("#dlgCrearActividad").modal("hide");
    },
    edittask(task) {
      this.errores = [];
      $("#dlgCrearActividad").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.customer_id = this.$route.params.id;
      this.taskSelected = task;
      $("#dlgCrearActividad").modal("show");
    },
    viewtask(task) {
      $("#dlgCrearActividad").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.customer_id = this.$route.params.id;
      this.taskSelected = task;
      this.disabledTask = true;
      $("#dlgCrearActividad").modal("show");
    },
    deletetask(task_id) {
      this.$swal({
        title: "Eliminar",
        text: "Desea eliminar la actividad ?",
        type: "question",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.value) {
          showLoader();
          this.$http
            .delete(`${this.$urlApi}tasks/${task_id}?token=${this.token}`, {
              headers: { "Content-Type": "application/json" },
            })
            .then(function (response) {
              //console.log(response)
              hideLoader();

              this.$swal({
                title: "Buen trabajo",
                text: "Actividad eliminada correctamente!",
                type: "success",
                showCancelButton: false,
                confirmButtonText: "Aceptar",
              }).then((result) => {
                if (result.value) {
                  this.getTasks();
                }
              });
            })
            .catch((error) => {
              console.log(error.body.error);
              hideLoader();
            });
        }
      });
    },
    actualizarEstadoTask() {
      let registrosActualizados = 0;

      for (var i = 0; i < this.lstTasks.length; i++) {
        var updatingItem = this.lstTasks[i];
        if (updatingItem.selected) {
          updatingItem.status_id = this.task_status;
          let id = updatingItem.id;
          let datos = JSON.stringify(updatingItem);

          this.$http
            .put(`${this.$urlApi}tasks/${id}?token=${this.token}`, datos, {
              headers: { "Content-Type": "application/json" },
            })
            .then(function (response) {})
            .catch((error) => {
              console.log(error.body.message);
            });
          registrosActualizados = registrosActualizados + 1;
        }
      }

      if (registrosActualizados > 0) {
        this.$swal({
          title: "Buen trabajo",
          text: "Actividades actualizados correctamente!",
          type: "success",
          showCancelButton: false,
          confirmButtonText: "Aceptar",
        }).then((result) => {
          if (result.value) {
            this.getTasks();
          }
        });
      }
      this.task_status = null;
    },
    editCustomer() {
      this.$router.push({
        path: `../../customers/edit/${this.customer.id.toString()}`,
      });
    },
    getTaskByType(type, esEditar) {
      showLoader();

      if (esEditar) {
        this.gestionAux.task_id = null;
        this.gestionAux.status_id = null;
      } else {
        this.gestion.task_id = null;
        this.gestion.status_id = null;
      }

      if (esEditar) this.lstTaskEditAux = {};
      else this.lstTaskEdit = {};

      let id = this.$route.params.id;
      // CARGAR EL LISTADO DE TAREAS O ACTIVIDADES DE ESTE CLIENTE, SEGUN EL TIPO DE ACTIVIDAD
      this.$http
        .get(
          `${this.$urlApi}tasks/customer/${id}/type/${type}?token=${this.token}`
        )
        .then(
          (response) => {
            if (esEditar) this.lstTaskEditAux = response.data.data;
            else this.lstTaskEdit = response.data.data;
            //response.data.data)
          },
          (error) => {
            console.log(error);
          }
        );
      hideLoader();
    },
    guardarGestion() {
      showLoader();
      this.gestion.customer_id = this.customer.id;
      let auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);
      this.gestion.user_id = auth[0].id;
      this.datos = JSON.stringify(this.gestion);

      this.$http
        .post(
          `${this.$urlApi}taskmanagements?token=${this.token}`,
          this.datos,
          { headers: { "Content-Type": "application/json" } }
        )
        .then(function (response) {
          // console.log(response)

          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Gestión guardada correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              this.gestion = {
                date: null,
                minutes: null,
                type: null,
                task_id: null,
                management: null,
                customer_id: null,
                user_id: null,
                status_id: null,
              };

              this.lstTaskEdit = [];
              this.taskEdit_id = null;

              this.getTaskManagement();
              this.getTasks();
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    actualizarGestion() {
      showLoader();
      this.gestionAux.customer_id = this.customer.id;
      let auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);
      // this.gestionAux.user_id = auth[0].id
      this.datos = JSON.stringify(this.gestionAux);

      this.$http
        .put(
          `${this.$urlApi}taskmanagements/${this.gestionAux.id}?token=${this.token}`,
          this.datos,
          { headers: { "Content-Type": "application/json" } }
        )
        .then(function (response) {
          //console.log(response)

          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Gestión actualizada correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              this.gestionAux = {
                date: null,
                minutes: null,
                type: null,
                task_id: null,
                management: null,
                customer_id: null,
                user_id: null,
                status_id: null,
              };

              this.lstTaskEditAux = [];
              this.getTaskManagement();
              this.getTasks();
              $("#dlgGestion").modal("hide");
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    closeGestion() {
      this.gestionAux = {
        date: null,
        minutes: null,
        type: null,
        task_id: null,
        management: null,
        customer_id: null,
        user_id: null,
        status_id: null,
      };
      this.lstTaskEditAux = [];

      $("#dlgGestion").modal("hide");
    },
    editGestion(gestion) {
      console.log(gestion);

      // VALIDAR SI ES UN COMERCIAL Y SI PUEDE EDITAR
      if (this.role_id != 1 && this.role_id != 7) {
        // VERIFICAR EL TIEMPO TRANSCURRIDO
        var fechaGestion = moment(gestion._created_at, "YYYY-MM-DD HH:mm:ss");
        var fechaActual = moment(new Date(), "YYYY-MM-DD HH:mm:ss");
        var dias = fechaActual.diff(fechaGestion, "days");
        var minutos = fechaActual.diff(fechaGestion, "m");

        if (dias > 0 || minutos > 10) {
          this.$swal({
            title: "Oops...",
            text:
              "La gestión ya superó los 10 minutos para ser editada, contacte con el administrador.",
            type: "error",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return false;
        }
      }

      this.errores = [];
      $("#dlgGestion").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.gestionAux = gestion;
      this.getTaskByType(this.gestionAux.type, true);
      $("#dlgGestion").modal("show");
    },
    deleteGestion(gestion) {
      // VALIDAR SI ES UN COMERCIAL Y SI PUEDE ELIMINAR
      if (!this.isAdmin) {
        // VERIFICAR EL TIEMPO TRANSCURRIDO
        var fechaGestion = moment(gestion._created_at, "YYYY-MM-DD HH:mm:ss");
        var fechaActual = moment(new Date(), "YYYY-MM-DD HH:mm:ss");
        var dias = fechaActual.diff(fechaGestion, "days");
        var minutos = fechaActual.diff(fechaGestion, "m");

        if (dias > 0 || minutos > 10) {
          this.$swal({
            title: "Oops...",
            text:
              "La gestión ya superó los 10 minutos para ser eliminada, contacte con el administrador.",
            type: "error",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return false;
        }
      }

      this.$swal({
        title: "Eliminar",
        text: "Desea eliminar la gestión ?",
        type: "question",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.value) {
          showLoader();
          this.$http
            .delete(
              `${this.$urlApi}taskmanagements/${gestion.id}?token=${this.token}`,
              { headers: { "Content-Type": "application/json" } }
            )
            .then(function (response) {
              //console.log(response)
              hideLoader();

              this.$swal({
                title: "Buen trabajo",
                text: "Gestión eliminada correctamente!",
                type: "success",
                showCancelButton: false,
                confirmButtonText: "Aceptar",
              }).then((result) => {
                if (result.value) {
                  this.getTaskManagement();
                }
              });
            })
            .catch((error) => {
              console.log(error.body.error);
              hideLoader();
            });
        }
      });
    },
    getTaskManagement: function (urlPage) {
      showLoader();
      let id = this.$route.params.id;
      // DETERMINAR EL NUMERO DE LA PAGINA
      let page = darNumeroPaginaPaginacion(urlPage);

      // ARMAR LA URL CON LA PAGINACIÓN
      let url = `${this.$urlApi}taskmanagements/customer/${id}?token=${this.token}&page=${page}`;

      this.$http
        .get(url, this.auth, {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          function (response) {
            this.lstGestion = response.data.data.data;
            this.paginationGestion = setPaginator(response.data.data);
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    getAdvanceLevel() {
      this.$http
        .get(
          `${this.$urlApi}parameters/advance/${this.customer.advance}?token=${this.token}`
        )
        .then(
          (response) => {
            this.lstAdvanceLevel = response.data.data;
          },
          (error) => {
            console.log(error);
          }
        );
    },
    changeAdvanceLevel() {
      showLoader();
      let id = this.customer.id;
      this.datos = JSON.stringify(this.customer);

      this.$http
        .put(
          `${this.$urlApi}customers/changeadvance/${id}?token=${this.token}`,
          this.datos,
          { headers: { "Content-Type": "application/json" } }
        )
        .then(function (response) {
          //console.log(response)
          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Registro actualizado correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              hideLoader();
            }
          });
        })
        .catch((error) => {
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    selectedTask(task_id, esEditar) {
      if (task_id != null) {
        if (esEditar) {
          this.gestionAux.task_id = null;
          this.gestionAux.status_id = null;
        } else {
          this.gestion.task_id = null;
          this.gestion.status_id = null;
        }

        showLoader();
        // CARGAR LA TAREA
        this.$http
          .get(`${this.$urlApi}tasks/${task_id}?token=${this.token}`)
          .then(
            (response) => {
              if (esEditar) {
                this.gestionAux.task_id = response.data.data.id;
                this.gestionAux.status_id = response.data.data.status_id;
              } else {
                this.gestion.task_id = response.data.data.id;
                this.gestion.status_id = response.data.data.status_id;
              }

              //console.log(response.data.data)
              hideLoader();
            },
            (error) => {
              hideLoader();
              console.log(error);
            }
          );
      }
    },
    validarTiempoDiarioGestiones(gestion) {
      if (gestion.date !== null && gestion.minutes !== null) {
        let auth = localStorage.getItem("auth");
        auth = JSON.parse(auth);

        var dateString = gestion.date.toString();
        var momentObj = moment(dateString, "DD/MM/YYYY h:mm A");
        var momentString = momentObj.format("YYYY-MM-DD");

        this.$http
          .get(
            `${this.$urlApi}taskmanagements/minutes/${auth[0].id}/${momentString}?token=${this.token}`
          )
          .then(
            (response) => {
              console.log(
                "Total minutos hoy => " + response.data.data.total_minutos
              );
              let totalMinutos =
                parseInt(response.data.data.total_minutos) +
                parseInt(gestion.minutes);

              if (totalMinutos > this.$maxMinutes) {
                this.$swal({
                  title: "Advertencia",
                  text: "Ya superó su cuota laboral del día! =>" + momentString,
                  type: "warning",
                  showCancelButton: false,
                  confirmButtonText: "Aceptar",
                });

                gestion.minutes = null;
                return false;
              }
            },
            (error) => {
              console.log(error);
            }
          );
      }
    },
    formatBirthdate(value) {
      return moment(value).format("DD") + " de " + moment(value).format("MMMM");
    },
    visible(item) {
      // console.log(item);
      if (item == undefined) return false;
      else if (item == null) return false;
      else if (item == null) return false;
      else if (Array.isArray(item) && item.length == 0) return false;
      else return true;
      // return item != undefined && item != null &&  (item.length > 0) ? true: false;
    },
  },
};
</script>
